import Vue from 'vue'
import store from '@/store'
import VueRouter from 'vue-router'
import routes, { RouteNames } from './routes'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'
import { UserScope } from '@/models/users'
import i18n from '@/i18n'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.auth)
  if (requiresAuth && !store.getters.isLoggedIn) {
    store.dispatch(ADD_TOAST_MESSAGE, {
      text: i18n.tc('auth.needAuthError'),
      type: 'warning',
    })
    return next(RouteNames.Login)
  }

  const requiresCompany = to.matched.some(record => record.meta.company)
  if (requiresCompany && !store.getters.getActiveCompany?.id) {
    store.dispatch(ADD_TOAST_MESSAGE, {
      text: i18n.tc('auth.missingCompanyError'),
      type: 'warning',
    })
    return next('/company/create')
  }

  next()
})

// Authorization of route access
router.beforeResolve((to, from, next) => {
  // Get required scopes
  const requiredScopes: UserScope[] = to.matched
    .map(one => one.meta?.scope)
    .filter(one => one)
  if (Array.isArray(requiredScopes) && requiredScopes.length > 0) {
    if (
      !requiredScopes.reduce(
        (prev: boolean, current: UserScope): boolean =>
          prev && store.getters.canDoScope(current),
        true,
      )
    ) {
      return next({
        name:
          from.name === RouteNames.BackwardReloader
            ? RouteNames.App
            : RouteNames.AccessBlocked,
        replace: true,
      })
    }
  }
  next()
})

router.afterEach((to, from) => {
  if (to.name === RouteNames.BackwardReloader) {
    const canBackwardReloading = from.matched.some(
      record => record.meta.backward,
    )
    if (canBackwardReloading && from.name) {
      return router.replace({ name: from.name })
    }
    return router.replace({ name: RouteNames.App })
  }
})

export default router

export { RouteNames }
